<div class="bar">
  <div class="switch" [class.active]="value" (click)="toggle()"></div>
</div>
